'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002eui$002e$002dInputs$0024$002dInput$002dVar$002dImpl from "./presto.ui.-Inputs$-Input-Var-Impl.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_Inputs$InputVar$() {
}
export { $c_Lpresto_ui_Inputs$InputVar$ as $c_Lpresto_ui_Inputs$InputVar$ };
$p = $c_Lpresto_ui_Inputs$InputVar$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_Inputs$InputVar$;
/** @constructor */
function $h_Lpresto_ui_Inputs$InputVar$() {
}
export { $h_Lpresto_ui_Inputs$InputVar$ as $h_Lpresto_ui_Inputs$InputVar$ };
$h_Lpresto_ui_Inputs$InputVar$.prototype = $p;
$p.ay = (function(maybe, codec) {
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.a5;
  if (maybe.k()) {
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
  } else {
    var arg1 = maybe.q();
    var $x_1 = codec.bK(arg1).dc();
  }
  return new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dVar$002dImpl.$c_Lpresto_ui_Inputs$InputVarImpl($x_2.a6($x_1), codec);
});
$p.cuM = (function(text, codec) {
  return this.ay(codec.bO(text).dc(), codec);
});
$p.af1 = (function(t, codec) {
  return this.ay(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some(t), codec);
});
$p.nz = (function(dftl, sa, sb, combinator) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().acG(sa, sb, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction2(((x$1, x$2) => {
    if ((x$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      var va = x$1.T;
      if ((x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
        var vb = x$2.T;
        return combinator.bx(va, vb);
      }
    }
    return dftl.ar();
  })));
});
$p.GM = (function(dftl, sa, sb, sc, combinator) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().cqu(sa, sb, sc, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction3(((x$1, x$2, x$3) => {
    if ((x$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      var va = x$1.T;
      if ((x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
        var vb = x$2.T;
        if ((x$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
          var vc = x$3.T;
          return combinator.sD(va, vb, vc);
        }
      }
    }
    return dftl.ar();
  })));
});
$p.r0 = (function(dftl, sa, sb, sc, sd, combinator) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().cqt(sa, sb, sc, sd, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction4(((x$1, x$2, x$3, x$4) => {
    if ((x$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      var va = x$1.T;
      if ((x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
        var vb = x$2.T;
        if ((x$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
          var vc = x$3.T;
          if ((x$4 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
            var vd = x$4.T;
            return combinator.a2l(va, vb, vc, vd);
          }
        }
      }
    }
    return dftl.ar();
  })));
});
$p.a2z = (function(dftl, sa, sb, sc, sd, se, combinator) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().cCH(sa, sb, sc, sd, se, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction5(((x$1, x$2, x$3, x$4, x$5) => {
    if ((x$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      var va = x$1.T;
      if ((x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
        var vb = x$2.T;
        if ((x$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
          var vc = x$3.T;
          if ((x$4 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
            var vd = x$4.T;
            if ((x$5 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
              var ve = x$5.T;
              return combinator.cpJ(va, vb, vc, vd, ve);
            }
          }
        }
      }
    }
    return dftl.ar();
  })));
});
$p.a2y = (function(dftl, sa, sb, sc, sd, se, sf, combinator) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().cqs(sa, sb, sc, sd, se, sf, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction6(((x$1, x$2, x$3, x$4, x$5, x$6) => {
    if ((x$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      var va = x$1.T;
      if ((x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
        var vb = x$2.T;
        if ((x$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
          var vc = x$3.T;
          if ((x$4 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
            var vd = x$4.T;
            if ((x$5 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
              var ve = x$5.T;
              if ((x$6 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
                var vf = x$6.T;
                return combinator.cpI(va, vb, vc, vd, ve, vf);
              }
            }
          }
        }
      }
    }
    return dftl.ar();
  })));
});
$p.cCA = (function(dftl, sa, sb, sc, sd, se, sf, sg, combinator) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().cCG(sa, sb, sc, sd, se, sf, sg, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction7(((x$1, x$2, x$3, x$4, x$5, x$6, x$7) => {
    if ((x$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      var va = x$1.T;
      if ((x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
        var vb = x$2.T;
        if ((x$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
          var vc = x$3.T;
          if ((x$4 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
            var vd = x$4.T;
            if ((x$5 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
              var ve = x$5.T;
              if ((x$6 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
                var vf = x$6.T;
                if ((x$7 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
                  var vg = x$7.T;
                  return combinator.cpH(va, vb, vc, vd, ve, vf, vg);
                }
              }
            }
          }
        }
      }
    }
    return dftl.ar();
  })));
});
$p.cCz = (function(dftl, sa, sb, sc, sd, se, sf, sg, sh, combinator) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().cqr(sa, sb, sc, sd, se, sf, sg, sh, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction8(((x$1, x$2, x$3, x$4, x$5, x$6, x$7, x$8) => {
    if ((x$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      var va = x$1.T;
      if ((x$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
        var vb = x$2.T;
        if ((x$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
          var vc = x$3.T;
          if ((x$4 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
            var vd = x$4.T;
            if ((x$5 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
              var ve = x$5.T;
              if ((x$6 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
                var vf = x$6.T;
                if ((x$7 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
                  var vg = x$7.T;
                  if ((x$8 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
                    var vh = x$8.T;
                    return combinator.cpG(va, vb, vc, vd, ve, vf, vg, vh);
                  }
                }
              }
            }
          }
        }
      }
    }
    return dftl.ar();
  })));
});
$p.cxf = (function(s1, s2) {
  var _1 = s1.Al();
  var _2 = s2.Al();
  if ((_1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
    var x143 = _1.a0;
    if ((x143 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      var a = x143.T;
      if ((_2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
        var x139 = _2.a0;
        if ((x139 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2(a, x139.T));
        }
      }
    }
  }
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), ""));
});
var $d_Lpresto_ui_Inputs$InputVar$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_Inputs$InputVar$, "presto.ui.Inputs$InputVar$", ({
  a4e: 1
}));
export { $d_Lpresto_ui_Inputs$InputVar$ as $d_Lpresto_ui_Inputs$InputVar$ };
var $n_Lpresto_ui_Inputs$InputVar$;
function $m_Lpresto_ui_Inputs$InputVar$() {
  if ((!$n_Lpresto_ui_Inputs$InputVar$)) {
    $n_Lpresto_ui_Inputs$InputVar$ = new $c_Lpresto_ui_Inputs$InputVar$();
  }
  return $n_Lpresto_ui_Inputs$InputVar$;
}
export { $m_Lpresto_ui_Inputs$InputVar$ as $m_Lpresto_ui_Inputs$InputVar$ };
//# sourceMappingURL=presto.ui.-Inputs$-Input-Var$.js.map
